import { render, staticRenderFns } from "./Workload.vue?vue&type=template&id=60e326a8&scoped=true"
import script from "./Workload.vue?vue&type=script&lang=js"
export * from "./Workload.vue?vue&type=script&lang=js"
import style0 from "./Workload.vue?vue&type=style&index=0&id=60e326a8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e326a8",
  null
  
)

export default component.exports